import React from 'react';
import { tw } from 'twind';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { useFeature } from 'hooks/useFeature';
import { useTranslate } from 'hooks/useTranslations';

export default function ProductStoryKeywords({ productKeywords }) {
  const router = useRouter();
  const t = useTranslate();
  const showProductStoryKeywordTitle = useFeature(
    'SHOW_PRODUCT_STORY_KEYWORD_TITLE'
  );
  return (
    <>
      {productKeywords?.length ? (
        <div className="mt-6 font-bold">
          <p>
            {showProductStoryKeywordTitle && (
              <span className="text-black-700">
                {`${t('productStoryKeywordTitle')}: `}
              </span>
            )}
            {productKeywords?.map((keyword: string, index: number) => (
              <React.Fragment key={`productKeywords-${index}`}>
                <span className={tw(`:hover:underline`)}>
                  <Link
                    href={`/${router.query.country}/${router.query.language}/search?q=${keyword}`}
                  >
                    {keyword}
                  </Link>
                </span>
                {index !== productKeywords.length - 1 && ', '}
              </React.Fragment>
            ))}
          </p>
        </div>
      ) : null}
    </>
  );
}
